module.exports = __webpack_public_path__ + "static/a8-d46137de50b8a18df9ee7f1227798244.png";